import React, { useState, useEffect } from 'react';
import '../theme.css';

interface HeaderProps {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  isLoggedIn: boolean;
  onLoginClick: () => void;
  activeSection: string;
  setActiveSection: (section: string) => void;
}

const Header: React.FC<HeaderProps> = ({
  theme,
  toggleTheme,
  activeSection,
  setActiveSection,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'projects', label: 'Projects' },
    { id: 'resume', label: 'Resume' },
    { id: 'contact', label: 'Contact' },
  ];

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(id);
      setMobileMenuOpen(false);
    }
  };


  return (
    <header className={`fixed w-full z-50 transition-all ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between py-4">

          {/* Logo */}
          <div
            className="cursor-pointer flex items-center gap-3"
            onClick={() => scrollToSection('home')}
          >
            <div>
              <div className="font-bold text-lg">Murtesa Developer</div>
              <div className="text-sm text-secondary">Full Stack Developer</div>
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`nav-button ${activeSection === item.id ? 'active' : ''}`}
              >
                {item.label}
              </button>
            ))}

            {/* Right Side */}
            <div className="flex items-center gap-4">

              {/* Theme Toggle */}
              <button onClick={toggleTheme} className="theme-toggle">
                {theme === 'dark' ? '☀️' : '🌙'}
              </button>
            </div>
          </nav>

          {/* Mobile Controls */}
          <div className="md:hidden flex items-center gap-4">
            
            <button onClick={toggleTheme} className="theme-toggle">
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              ☰
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu open">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="nav-button w-full text-left"
              >
                {item.label}
              </button>
            ))}

          
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
